import React, { useMemo } from 'react';
import ReactSelect from 'react-select';
import { Button, Card } from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

const AssignDriverForm = ({
    drivers,
    selectedDriver,
    setSelectedDriver,
    assignmentDate,
    setAssignmentDate,
    weeklyRate,
    setWeeklyRate,
    notes,
    setNotes,
    onAssign
}) => {
    const driverOptions = useMemo(() => (Array.isArray(drivers) ? drivers.map(d => ({ value: d.id_no, label: d.name })) : []), [drivers]);

    const selectedOption = useMemo(() => driverOptions.find(o => o.value === selectedDriver) || null, [driverOptions, selectedDriver]);

    const selectStyles = useMemo(() => ({
        control: (provided, state) => ({
            ...provided,
            minHeight: '44px',
            borderRadius: '0.5rem',
            borderColor: state.isFocused ? '#FF5733' : '#e5e7eb',
            boxShadow: state.isFocused ? '0 0 0 6px rgba(255,87,51,0.08)' : 'none',
            '&:hover': { borderColor: '#ff6f45' },
            backgroundColor: '#ffffff'
        }),
        singleValue: (provided) => ({ ...provided, color: '#2a2e30', fontSize: '0.9rem' }),
        menu: (provided) => ({ ...provided, borderRadius: '0.5rem', boxShadow: '0 6px 18px rgba(15,23,42,0.08)' }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#fff7ed' : (state.isSelected ? '#ffedd5' : '#ffffff'),
            color: state.isSelected ? '#7c2d12' : '#111827',
            padding: '8px 12px'
        }),
        placeholder: (provided) => ({ ...provided, color: '#6b7280' }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (provided) => ({ ...provided, color: '#FF5733' }),
        menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
    }), []);
    return (
        <Card className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 mb-8">
            <form onSubmit={onAssign} className="w-full">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-start mb-6">
                    <div>
                        <label htmlFor="driver" className="block text-sm font-medium text-blue-gray-700 mb-2">
                            Select Driver
                        </label>
                        <div>
                            <ReactSelect
                                id="driver"
                                options={driverOptions}
                                value={selectedOption}
                                onChange={(option) => setSelectedDriver(option ? option.value : '')}
                                isClearable
                                isSearchable
                                placeholder="-- Select Driver --"
                                classNamePrefix="react-select"
                                styles={selectStyles}
                                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                menuPosition="fixed"
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="assignmentDate" className="block text-sm font-medium text-blue-gray-700 mb-2">
                            Assignment Date
                        </label>
                        <input
                            type="date"
                            id="assignmentDate"
                            value={assignmentDate || new Date().toISOString().split('T')[0]}
                            onChange={(e) => setAssignmentDate(e.target.value)}
                            className="w-full px-3 py-2.5 border border-blue-gray-200 rounded-lg text-blue-gray-700 outline outline-0 focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 transition-all"
                        />
                    </div>

                    <div>
                        <label htmlFor="weeklyRate" className="block text-sm font-medium text-blue-gray-700 mb-2">
                            Weekly Rate
                        </label>
                        <input
                            type="number"
                            id="weeklyRate"
                            value={weeklyRate}
                            onChange={(e) => setWeeklyRate(Number(e.target.value))}
                            className="w-full px-3 py-2.5 border border-blue-gray-200 rounded-lg text-blue-gray-700 outline outline-0 focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 transition-all text-right"
                        />
                    </div>

                    <div>
                        <label htmlFor="notes" className="block text-sm font-medium text-blue-gray-700 mb-2">
                            Notes (Optional)
                        </label>
                        <input
                            type="text"
                            id="notes"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Add notes..."
                            className="w-full px-3 py-2.5 border border-blue-gray-200 rounded-lg text-blue-gray-700 outline outline-0 focus:border-brand-primary focus:ring-2 focus:ring-brand-primary/20 transition-all"
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <Button
                        type="submit"
                        className="flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary/90 text-white rounded-full py-3 px-8 border-0"
                    >
                        <FontAwesomeIcon icon={faUserPlus} />
                        Assign Driver
                    </Button>
                </div>
            </form>
        </Card>
    );
};

export default AssignDriverForm;
